import { render, staticRenderFns } from "./ViewStream.vue?vue&type=template&id=587f2598&scoped=true"
import script from "./ViewStream.vue?vue&type=script&lang=js"
export * from "./ViewStream.vue?vue&type=script&lang=js"
import style0 from "./ViewStream.vue?vue&type=style&index=0&id=587f2598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f2598",
  null
  
)

export default component.exports